import client from '@/api/client';
import { gql } from '@apollo/client';
import trainingFragments from '@/gql-fragments/training-element';

interface TrainingResult {
  id?: number;
  correct: string;
  answer: string;
  isCorrect: boolean;
  trainingType?: string;
  elementType?: string;
  session?: string;
  courseElement?: string;
}

const getTrainingElements = (
  params: {
    exerciseId: string;
  },
) => client.query({
  query: gql`
    query($exerciseId: Int) {
      getTrainingElements(exerciseId: $exerciseId) {
        ...TrainingElement
      }
    }
    ${trainingFragments.TrainingElement}
  `,
  variables: {
    exerciseId: parseInt(params.exerciseId, 10),
  },
});

const setTrainingResult = (trainingResult: TrainingResult) => client.mutate({
  mutation: gql`
    mutation(
      $trainingResult: TrainingResultSetInput,
    ) {
      trainingResultSet(
        trainingResult: $trainingResult,
      ) {
        id
      }
    }
  `,
  variables: {
    trainingResult,
  },
});

const updateTrainingResult = (
  id: number,
  trainingResult: {
    correct: string;
    answer: string;
    isCorrect: boolean;
    trainingType: string;
  },
) => client.mutate({
  mutation: gql`
    mutation(
      $id: Int,
      $trainingResult: TrainingResultSetInput,
    ) {
      trainingResultUpdate(
        id: $id,
        trainingResult: $trainingResult,
      ) {
        status
      }
    }
  `,
  variables: {
    id,
    trainingResult,
  },
});

const getHomeworkElements = (ids: [number], sessionId: string) => client.query({
  query: gql`
    query (${ids.map((_, i) => `$ex_${i}: Int`).join('\n')}, $sessionId: String) {
      ${ids.map((id, i) => `
        ex_${id}: getTrainingElements(exerciseId: $ex_${i}, sessionId: $sessionId) {
          id
          en
          enGaps
          allowedTrainingTypes
          elementAnswers {
            id
            answer
            isCorrect
            mistake {
              answer
              is_correct
            }
            trainingType
          }
        }
      `).join('')}
    }
  `,
  variables: {
    ...ids.reduce((memo, el, i) => ({ ...memo, [`ex_${i}`]: el }), {}),
    sessionId,
  },
});

export {
  getTrainingElements,
  getHomeworkElements,
  setTrainingResult,
  updateTrainingResult,
};
